<template>
    <div class="field-checkboxes field-wrap" :class="{ 'field-checkboxes--large': large }">
        <label v-if="label || required" class="field-checkboxes__general-label">
            {{ label
            }}<span v-if="required" class="field-checkboxes__general-label-required">&nbsp;*</span>
        </label>
        <ul class="field-checkboxes__list">
            <li
                v-for="(items__value, items__key) in options"
                v-bind:key="items__key"
                class="field-checkboxes__list-item"
            >
                <input
                    :id="items__key"
                    type="checkbox"
                    :checked="isItemChecked(Array.isArray(options) ? items__value : items__key)"
                    @change="checkItem(Array.isArray(options) ? items__value : items__key, $event)"
                    class="field-checkboxes__input"
                />
                <label :for="items__key" class="field-checkboxes__label"
                    ><span class="field-checkboxes__pseudo-checkbox"></span
                    >{{
                        typeof items__value === 'object' &&
                        'data' in items__value &&
                        'name' in items__value.data
                            ? items__value.data.name
                            : items__value
                    }}</label
                >
            </li>
        </ul>
    </div>
</template>

<script>
import deepEql from 'deep-eql';
import { mapGetters, mapActions } from 'vuex';
import { toArray } from '@/helpers/utils';
import { ComplexFieldMixin } from '@/mixins/ComplexFieldMixin';

export default {
    data() {
        return {};
    },
    components: {},
    methods: {
        ...mapActions(['addProp', 'removeProp', 'setProp']),
        /* init */
        async init() {
            let cur = this.getProp(this.dataSource);
            if (this.default === 'all' && (cur === undefined || cur === null)) {
                for (let item__key of Object.keys(this.options)) {
                    await this.addProp({
                        source: this.dataSource,
                        value: Array.isArray(this.options) ? this.options[item__key] : item__key
                    });
                }
            }
        },
        /* validate */
        validate(val) {
            return !this.required || toArray(val).length > 0;
        },
        /* custom setters */
        async checkItem(val, e) {
            await this.componentDifferChange();
            // add
            if (e.target.checked === true) {
                await this.addProp({
                    source: this.dataSource,
                    value: val
                });
            }
            // delete
            else {
                let obj = this.getProp(this.dataSource);
                let key = Object.keys(obj).find((i) => deepEql(obj[i], val));
                if (key !== undefined) {
                    await this.removeProp({
                        source: this.dataSource + '.' + key
                    });
                }
            }
            await this.componentDifferValidate();
        },
        /* custom getters */
        isItemChecked(val) {
            return toArray(this.getProp(this.dataSource)).some((i) => deepEql(i, val));
        }
    },
    computed: {
        ...mapGetters(['getProp'])
    },
    props: {
        dataSource: String,
        options: [Object, Array],
        label: String,
        required: Boolean,
        default: String,
        large: {
            type: Boolean,
            default: false
        }
    },
    mixins: [ComplexFieldMixin]
};
</script>
